import React from "react";

// Components
import Table from "../../presenters/table";
import Skeleton from "react-loading-skeleton";
import moment from "moment";

/**
 * Display a table with the statistics of the backtested
 * portfolio
 *
 * @param {Portfolio} portfolio the backtested portfolio
 * @returns
 * @author Giovanna Marinelli
 */
const StatisticsTable = ({ portfolio, portfolioExPandhora }) => {
  /**
   * Format a numeric value as a number with two decimal places
   *
   * @param {number} val The numeric value
   * @returns the formated numeric value
   */
  const formatNumeric = (val) => {
    return val ? val.toFixed(2) : "0.00";
  };

  /**
   * Format a numeric value as a percentage with two decimal places
   *
   * @param {number} val The numeric value to be formatted
   * @returns the formated numeric value
   */
  const formatPercentage = (val) => {
    return val ? (100 * val).toFixed(2) + "%" : "0.00%";
  };

  /**
   * Returns a string containing the date range in which
   * the client portfolio was backtested
   *
   * @returns a string with the date range
   */
  const portfolioDateRange = () => {
    if (
      portfolio &&
      portfolio.returns &&
      Object.keys(portfolio.returns).length > 0
    ) {
      const dates = Object.keys(portfolio.returns);
      const startDate = new Date(dates[0] + "T00:00:00");
      const endDate = new Date(dates[dates.length - 1] + "T00:00:00");
      const startDateStr = moment(startDate).format("DD/MM/YYYY");
      const endDateStr = moment(endDate).format("DD/MM/YYYY");

      return `(de ${startDateStr} a ${endDateStr})`;
    }
    return undefined;
  };

  return (
    <div className="StatisticsTable__container container">
      <div className="col">
        <div className="StatisticsTable__title">
          Estatísticas de performance
        </div>
      </div>
      <div className="col">
        <div className="StatisticsTable__daterange">
          {portfolio ? portfolioDateRange() : <Skeleton width="30%" />}
        </div>
      </div>
      {portfolio ? (
        <Table>
          <Table.Head>
            <Table.Tr>
              <Table.Th
                className="StatisticsTable__rowindex"
                scope="col"
              ></Table.Th>
              <Table.Th className="StatisticsTable__th" scope="col">
                Carteira com a Pandhora
              </Table.Th>
              <Table.Th className="StatisticsTable__th" scope="col">
                Sua carteira atual
              </Table.Th>
            </Table.Tr>
          </Table.Head>
          <Table.Body>
            <Table.Tr>
              <Table.Th scope="row">Sharpe</Table.Th>
              <Table.Td className="StatisticsTable__td">
                {formatNumeric(portfolio.sharpe())}
              </Table.Td>
              <Table.Td className="StatisticsTable__td">
                {" "}
                {formatNumeric(portfolioExPandhora.sharpe())}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th scope="row">Retorno anualizado</Table.Th>
              <Table.Td className="StatisticsTable__td">
                {formatPercentage(portfolio.cagr())}
              </Table.Td>
              <Table.Td className="StatisticsTable__td">
                {" "}
                {formatPercentage(portfolioExPandhora.cagr())}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th scope="row">Volatilidade anualizada</Table.Th>
              <Table.Td className="StatisticsTable__td">
                {formatPercentage(portfolio.volatility())}
              </Table.Td>
              <Table.Td className="StatisticsTable__td">
                {" "}
                {formatPercentage(portfolioExPandhora.volatility())}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th scope="row">Max. Drawdown</Table.Th>
              <Table.Td className="StatisticsTable__td">
                {formatPercentage(portfolio.maxDrawdown())}
              </Table.Td>
              <Table.Td className="StatisticsTable__td">
                {" "}
                {formatPercentage(portfolioExPandhora.maxDrawdown())}
              </Table.Td>
            </Table.Tr>
          </Table.Body>
        </Table>
      ) : (
        <Skeleton count={7} />
      )}
    </div>
  );
};

export default StatisticsTable;
